import React from 'react'
import { Group, Rect, Text } from 'react-konva'
import type { DragModeName, DragRect } from '../types'
import { BANK_OFFSET_X, BANK_OFFSET_Y, BOUNDARY_GAP, CELL_GAP, CELL_SIZE, DRAG_MODES, MAP_OFFSET_X, MAP_OFFSET_Y } from '../constants'

interface DragOverlayProps {
  rect: DragRect | null
  mode: DragModeName
  active: boolean
  target: 'map' | 'bank' | 'side' | null
  cellCount?: number
}

export const DragOverlay: React.FC<DragOverlayProps> = ({ rect, mode, active, target, cellCount }) => {
  if (!active || !rect || !target || target === 'side') return null

  const modeConfig = DRAG_MODES[mode] ?? DRAG_MODES.tie
  const fillColor = modeConfig.color

  let x: number, y: number, width: number, height: number

  if (target === 'map') {
    const boundaryStartX = rect.startCol >= 5 ? BOUNDARY_GAP : 0
    const boundaryStartY = rect.startRow >= 5 ? BOUNDARY_GAP : 0
    const boundaryEndX = rect.endCol >= 5 ? BOUNDARY_GAP : 0
    const boundaryEndY = rect.endRow >= 5 ? BOUNDARY_GAP : 0

    x = MAP_OFFSET_X + rect.startCol * (CELL_SIZE + CELL_GAP) + boundaryStartX - 2
    y = MAP_OFFSET_Y + rect.startRow * (CELL_SIZE + CELL_GAP) + boundaryStartY - 2
    width = (rect.endCol - rect.startCol + 1) * (CELL_SIZE + CELL_GAP) - CELL_GAP + (boundaryEndX - boundaryStartX) + 4
    height = (rect.endRow - rect.startRow + 1) * (CELL_SIZE + CELL_GAP) - CELL_GAP + (boundaryEndY - boundaryStartY) + 4
  } else {
    // bank (Bank.tsx의 GRID_PAD_X=90, GRID_PAD_Y=20과 일치)
    x = BANK_OFFSET_X + 90 + rect.startCol * (CELL_SIZE + CELL_GAP) - 2
    y = BANK_OFFSET_Y + 20 + rect.startRow * (CELL_SIZE + CELL_GAP) - 2
    width = (rect.endCol - rect.startCol + 1) * (CELL_SIZE + CELL_GAP) - CELL_GAP + 4
    height = (rect.endRow - rect.startRow + 1) * (CELL_SIZE + CELL_GAP) - CELL_GAP + 4
  }

  return (
    <Group listening={false}>
      <Rect
        x={x}
        y={y}
        width={width}
        height={height}
        fill={fillColor}
        stroke={fillColor.replace('0.3', '0.8')}
        strokeWidth={2}
        cornerRadius={4}
      />
      {cellCount != null && cellCount > 0 && (
        <Text
          x={x}
          y={y}
          width={width}
          height={height}
          text={String(cellCount)}
          fontSize={Math.min(28, 18 + cellCount)}
          fontStyle="bold" fontFamily="CookeiRunBlack"
          fill="rgba(0,0,0,0.5)"
          align="center"
          verticalAlign="middle"
        />
      )}
    </Group>
  )
}
